module.exports = __webpack_public_path__ + "static/media/login-splash.c51f2a00.jpg";